export const MediaDataMulheres = [
  { img: "/Images/Women/1.jpeg" },
  { img: "/Images/Women/2.jpeg" },
  { img: "/Images/Women/3.jpeg" },
  { img: "/Images/Women/4.jpeg" },
  { img: "/Images/Women/5.jpeg" },
  { img: "/Images/Women/6.jpeg" },
  { img: "/Images/Women/7.jpeg" },
  { img: "/Images/Women/8.jpeg" },
  { img: "/Images/Women/9.jpeg" },
  { img: "/Images/Women/10.jpeg" },
  { img: "/Images/Women/11.jpeg" },
  { img: "/Images/Women/12.jpeg" },
];
